import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';

const Contact = () => {
  return (
    <div className="pt-20 pb-32 max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeIn className="text-center mb-12">
        <h1 className="text-4xl md:text-6xl font-black mb-4 text-white drop-shadow-[0_2px_20px_rgba(255,255,255,0.2)]">Get in touch</h1>
        <p className="text-xl text-white/80 drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">Have a question? We'd love to hear from you.</p>
      </FadeIn>

      <FadeIn className="glass-card p-8 md:p-10 border-2 border-brand-border/60">
        <form className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-white/80 mb-2">Name</label>
              <input 
                type="text" 
                className="w-full bg-brand-darker border-2 border-brand-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-electric transition-colors" 
                placeholder="John Doe" 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-white/80 mb-2">Email</label>
              <input 
                type="email" 
                className="w-full bg-brand-darker border-2 border-brand-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-electric transition-colors" 
                placeholder="john@example.com" 
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-white/80 mb-2">Subject</label>
            <select className="w-full bg-brand-darker border-2 border-brand-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-electric appearance-none transition-colors">
              <option>Sales Inquiry</option>
              <option>Support</option>
              <option>Partnership</option>
              <option>Press</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-white/80 mb-2">Message</label>
            <textarea 
              rows={4} 
              className="w-full bg-brand-darker border-2 border-brand-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-brand-electric resize-none transition-colors" 
              placeholder="How can we help?"
            ></textarea>
          </div>

          <button type="button" className="btn-primary w-full py-4 text-lg">Send Message</button>
        </form>

        <div className="mt-8 text-center text-sm text-white/70">
          <p>or</p>
          <a href="#" className="text-brand-electric hover:underline mt-2 inline-block">book a 20-min demo call →</a>
        </div>
      </FadeIn>
    </div>
  );
};

export default Contact;